import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationDeviceOperationCreateRequest,
    ConfigurationDeviceOperationResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-operation/configuration-device-operation.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationDeviceOperationService {
    async create(laboratoryId: number, request: ConfigurationDeviceOperationCreateRequest): Promise<ConfigurationDeviceOperationResponse> {
        const response = await axios.post<ConfigurationDeviceOperationResponse>(`/configuration/laboratories/${laboratoryId}/deviceOperation`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationDeviceOperationResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDeviceOperationResponse>>(`/configuration/laboratories/${laboratoryId}/deviceOperations`, { ...filterModel }, { params })
        return response.data
    }

    async delete(laboratoryId: number, deviceOperationId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/deviceOperations/${deviceOperationId}`)
        return response.data
    }
}

export const configurationDeviceOperationService = new ConfigurationDeviceOperationService()
